export default class Service {
    constructor() {
        this.LANGUAGE = '/' + document.documentElement.lang;
        this.getOrdersURL = this.LANGUAGE + '/profile/orders/list';
        this.period = 'week';

        //Services
        this.getServiceURL = this.LANGUAGE + '/profile/service/list';
    }

    /**
     *
     * @param url
     * @param data
     * @param callback
     * @private
     */
    _POST(url, data, callback) {
        let formData = new FormData();

        if(data) {
            for (let property in data) {
                formData.append(property, data[property]);
            }
        }

        $.ajax({
            type: "POST",
            url: url,
            processData: false,
            contentType: false,
            data: formData
        }).done(function (res) {
            callback(res);
        });
    }

    preloader(status) {
        let $owP = $('.overlay_page');
        if(status === true) {
            $owP.prepend('<img style="position: absolute;left: 50%;top:50%;transform: translate(-50%, -50%)" src="/assets/images/svg/preloader.svg">');
            $owP.fadeIn(200);
        } else {
            $owP.fadeOut(200, function () {
                $owP.find('img').remove();
            });
        }
    }
}
